import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Dropdown, Space, type MenuProps } from 'antd';
import { DownOutlined, TranslationOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import { Locale } from '@prisma/client';
import {
  mapLocaleEnumToString,
  mapLocaleStringToEnum,
} from '~/utils/localization';

const LanguageSwitcher: React.FC = () => {
  const { t } = useTranslation<'common'>('common');
  const router = useRouter();
  const [currentLocale, setCurrentLocale] = React.useState<string>(
    Locale.en_US,
  );

  const items: MenuProps['items'] = Object.values(Locale).map((locale) => ({
    label: t(`locales.${locale}`),
    key: locale,
  }));

  const onClick: MenuProps['onClick'] = ({ key }) => {
    /**
     * Set the locale cookie
     *
     * see: https://nextjs.org/docs/advanced-features/i18n-routing#leveraging-the-next_locale-cookie
     */
    Cookies.set('NEXT_LOCALE', mapLocaleEnumToString(key as Locale));

    setCurrentLocale(key as Locale);

    router.reload();
  };

  useEffect(() => {
    // set current locale
    setCurrentLocale(
      Cookies.get('NEXT_LOCALE')
        ? mapLocaleStringToEnum(Cookies.get('NEXT_LOCALE') as LocaleString)
        : Locale.en_US,
    );
  }, []);

  return (
    <Dropdown menu={{ items, onClick }}>
      <Space>
        <TranslationOutlined />
        {t(`locales.${currentLocale as Locale}`)}
        <DownOutlined />
      </Space>
    </Dropdown>
  );
};

export default LanguageSwitcher;
